import Vue from 'vue';
import install from "./install";

// TODO: Are placeholder values still necessary?

class VueAnchors {
	static install() {}

	constructor() {
		this.anchors = Vue.observable({});
		this.id = 0;
	}

	register(anchor) {
		if (this.canCreateAnchor(anchor)) {
			this.create(anchor);
		} else if (anchor.register) {
			// eslint-disable-next-line no-console
			console.warn(`Anchor with name ${anchor.name} already registered. If you wish to
			group this anchor please pass true to the group property.`);
		}

		return this.anchors[anchor.name];
	}

	canCreateAnchor(anchor) {
		const registered = this.anchorRegsitered(anchor.name);
		const elemntInDom = registered && document.body.contains(this.anchors[anchor.name].element);
		return !registered || !elemntInDom || anchor.updating || (registered && anchor.group);
	}

	anchorRegsitered(name) {
		return this.anchorExists(name) && !this.anchors[name].isPlaceholder;
	}

	anchorExists(name) {
		return typeof this.anchors[name] !== "undefined";
	}

	create(anchor) {
		const reactiveAnchor = this.createReactive(anchor);

		if (!anchor.group) {
			Vue.set(this.anchors, anchor.name, reactiveAnchor);
		} else {
			this.groupRegister(reactiveAnchor);
		}

		return this.anchors[anchor.name];
	}

	createReactive(anchor) {
		const presets = this.getPresets(anchor);
		return Vue.observable({ ...anchor, ...presets });
	}

	getPresets(anchor) {
		return {
			id: anchor.id ? anchor.id : this.generateId(),
			loaded: typeof anchor.loaded !== "undefined" ? anchor.loaded : true,
			isPlaceholder: typeof anchor.isPlaceholder !== "undefined" ? anchor.isPlaceholder : false,
		};
	}

	generateId() {
		this.id += 1;
		return this.id;
	}

	groupRegister(anchor) {
		if (!this.anchorExists(anchor.name) || this.anchors[anchor.name].isPlaceholder) {
			Vue.set(this.anchors, anchor.name, []);
		}

		this.anchors[anchor.name].push(anchor);
	}

	unregister(anchor) {
		if (!this.isGroup(anchor)) {
			Vue.delete(this.anchors, anchor.name);
		} else {
			this.groupUnregister(anchor);
		}
	}

	isGroup(anchor) {
		return Array.isArray(this.anchors[anchor.name]);
	}

	groupUnregister(anchor) {
		const index = this.anchors[anchor.name].findIndex((registered) => registered.id === anchor.id);
		this.anchors[anchor.name].splice(index, 1);

		if (!this.anchors[anchor.name]) {
			Vue.delete(this.anchors, anchor.name);
		}
	}

	get(name) {
		let anchor = this.anchors[name];

		if (!this.anchorExists(name)) {
			anchor = this.register({ name, loaded: false, register: true, isPlaceholder: true });
		}

		return anchor;
	}

	// TODO: Need a way to get a single element from a group of anchors?
	// TODO: Need a way to get a common ancestor of a group of anchors?

	update(anchor) {
		let id = false;

		if (anchor.register && !this.anchorExists(anchor.name)) {
			id = this.register(anchor);
		} else if (!anchor.register && this.anchorExists(anchor.name)) {
			this.unregister(anchor);
		} else if (anchor.register && this.anchorExists(anchor.name) && !this.isGroup(anchor)) {
			id = this.updateSingle(anchor);
		} else if (anchor.register && this.anchorExists(anchor.name) && this.isGroup(anchor)) {
			if (anchor.id === false) {
				const registered = this.create(anchor);
				id = registered[registered.length - 1].id;
			} else {
				id = this.updategroup(anchor);
			}
		}

		return id;
	}

	updateSingle(anchor) {
		const reactiveAnchor = this.createReactive(anchor);
		Vue.set(this.anchors, anchor.name, reactiveAnchor);
		return anchor.id;
	}

	updategroup(anchor) {
		const reactiveAnchor = this.createReactive(anchor);

		const index = this.anchors[anchor.name].findIndex((registered) => registered.id === anchor.id);
		Vue.set(this.anchors[anchor.name], index, reactiveAnchor);

		return anchor.id;
	}
}

VueAnchors.install = install;

export default VueAnchors;



// WEBPACK FOOTER //
// ./src/plugins/vue-anchors-plugin/VueAnchors.js